/**
 * Iterates over elements of collection, returning the first element predicate returns truthy for.
 * The predicate is invoked with three arguments: (value, index|key, collection).
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {string|undefined} Returns the matched element, else undefined.
 */

function callback(collection, predicate) {
	if (predicate.constructor === Object) {
		for (let element of collection) {
			let result = true
			for (let obj in predicate) {
				//search for key and value match
				result = Object.prototype.hasOwnProperty.call(element, obj)
					? element[obj] === predicate[obj] && result
					: false
			}
			if (result) {
				return element
			}
		}
		return undefined
	} else if (predicate.constructor === Array) {
		for (let element of collection) {
			if (Object.prototype.hasOwnProperty.call(element, predicate[0])) {
				//search for key and value match
				if (element[predicate[0]] === predicate[1]) {
					return element
				}
			}
		}
		return undefined
	} else if (predicate.constructor === String) {
		for (let element of collection) {
			if (Object.prototype.hasOwnProperty.call(element, predicate)) {
				if (element[predicate]) return element
			}
		}
		return undefined
	}
}

export default function find(collection, predicate) {
	if (collection) {
		if (Array.isArray(collection)) {
			//check whether predicate if given or not
			if (predicate) {
				if (predicate.constructor === Function) {
					return collection.find(predicate)
				} else {
					//if predicate is not a function
					return callback(collection, predicate)
				}
			} else {
				return collection[0]
			}
		} else if (collection.constructor === Object) {
			//check whether predicate if given or not
			if (predicate) {
				if (predicate.constructor === Function) {
					for (let obj of Object.keys(collection)) {
						if (predicate(collection[obj], obj, collection)) {
							return collection[obj]
						}
					}
				} else {
					//if predicate is not a function
					return callback(Object.values(collection), predicate)
				}
			} else {
				return Object.values(collection)[0]
			}
		}
	}
}
